module.exports = __webpack_public_path__ + "static/media/52_Print.bbf5d252.png";